import useToast from 'hooks/useToast';
import { IErrRes } from '../../type/db';
import { apis } from 'apis/apis';
import { useQuery } from 'react-query';
import useCommonStore from 'store/useCommonStore';
import { PlatformCode } from 'type/common';
import useAuthOver from 'hooks/useAuthOver';

// 찾기 리스트
export const useGetRankingListQuery = <T>(options?: T) => {
	const { platform, setPlatform } = useCommonStore();
	const platform_code = platform.code as PlatformCode;

	const [authOverCondition, setAuthOverError] = useAuthOver();

	const toast = useToast();

	return useQuery(
		['rank_list', platform_code],
		() => apis.getRankingList(platform_code),
		{
			retry: 0,
			enabled: platform_code !== null,
			onError: (err: IErrRes) => {
				if (authOverCondition(err)) {
					setAuthOverError();
				} else toast('Top100을 불러오지 못했습니다.', false, true);
			},
			staleTime: 3600000,
			cacheTime: Infinity,
			...options,
		},
	);
};
